<!--
 * @Author: linrui
 * @Date: 2021-12-22 17:11:41
 * @LastEditors: linrui
 * @LastEditTime: 2022-01-25 15:40:19
 * @FilePath: /wechat-frontend/zmtx/src/views/doctor/multipleChoicesExam.vue
-->
<template>
    <div class="choice-exam">
        <p class="exam-title multiple-exam-title">多选题</p>
        <div class="choice-lists-box">
            <div class="choice-lists-item" v-for="(item,index) in choiceLists" :key="index">
                <p class="choice-lists-title">{{ item.content }}</p>
                <div class="choice-lists" :class="chosenStyle(index, cindex,'bgClass')" v-for="(citem,cindex) in item.options" :key="cindex" @click="chooseChoice(index,cindex)">
                    <p class="choice-lists-single" >{{ citem }}</p>
                    <van-icon v-if="chosenStyle(index, cindex,'correctIcon')" name="success" size="16px" color="#1CB49D" />
                    <van-icon v-if="chosenStyle(index, cindex,'errorIcon')" name="cross" size="16px" color="#f7575e" />
                </div>
            </div>
        </div>
        <div class="page-ft btn">
            <van-row>
                <van-col span="8">
                    <van-button class="back" @click="goBackStep">返回</van-button>
                </van-col>
                <van-col span="16">
                    <van-button class="up" :disabled="btnDisabled" @click="submit">{{ submitBtnText }}</van-button>
                </van-col>
            </van-row>
        </div>
        <van-dialog v-model="showDialog" :confirm-button-text="confirmBtnText" confirm-button-color="#0AA8AF" @confirm="handleDialogConfirm">
            <div class="dialog-box">
                <div class="dialog-img">
                    <img :src="dialogImg" />
                </div>
                <p>{{ dialogMessage }}</p>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import correctImg from '@/assets/correctImg.png'
import errorImg from '@/assets/errorImg.png'
import {
    GetExamQuestions,
    SubmitDocExamRecord
} from '../../api/api'
import { mapState } from 'vuex'
export default {
    data() {
        return {
            correctImg,//笑脸考试通过过图片
            errorImg,//哭脸考试不及格图片
            showErrorChoices:false,//当前是否是错题展示
            btnDisabled:false,//是否禁用提交按钮
            showDialog:false,//展示对话框
            dialogImg:'',//对话框苦笑脸图片
            dialogMessage:'',//对话框提示语
            confirmBtnText:'',//对话确认按钮文本
            submitBtnText:'提交',//提交按钮文本
            formChosenResults:[],//要提交的选中答案的集合表单
            choiceLists:[],//多选题试题集合
            chosenResultsArr:[],//选中多选题的集合
            correctResultsArr:[],//多选题正确答案的集合
            errorResultsArr:[],//多选题正确答案的集合
        }
    },

    computed: {
        ...mapState({
            doctorInfo: state => state.doctor.doctorInfo
        }),
        chosenStyle:{
            get() {
                /**
                 * @description: 
                 * @param {Number} index 当前单选题题号-1
                 * @param {Number} cindex 当前单选题选项下标(从0开始)
                 * @param {String} key 【bgClass,correctIcon,errorIcon】中的某个键值,对应选中的、正确的、错误的选项的【背景色，是否展示正确选项绿勾，是否展示错误选项红叉】
                 * @return {String/Boolean} 选项根据选中的结果集合、正确答案的集合、错误答案的集合展示不同的样式
                 */                
                return (index,cindex,key) => {
                    let tempObj ={}
                    if(!this.showErrorChoices) {
                        if(this.chosenResultsArr[index] && this.chosenResultsArr[index].includes(cindex)) {
                            tempObj.bgClass = 'choice-chosen-correct'
                        }
                    } else {
                        if(this.correctResultsArr[index] && this.correctResultsArr[index].includes(cindex)) {
                            tempObj.bgClass = 'choice-chosen-correct'
                            tempObj.correctIcon = true
                        }
                        if(this.errorResultsArr[index] && this.errorResultsArr[index].includes(cindex)) {
                            if(this.correctResultsArr[index] && this.correctResultsArr[index].includes(cindex)) {
                                tempObj.bgClass = 'choice-chosen-error'
                                tempObj.correctIcon = true
                            } else {
                                tempObj.bgClass = 'choice-chosen-error'
                                tempObj.errorIcon = true
                            }
                        }
                    }
                    return tempObj[key]
                }
            }
        }
    },

    created() {
        this.$toast.loading({
            message:'加载中',
            duration:0,
            forbidClick:true
        })
        GetExamQuestions({
            type:'多选'
        }).then( res => {
            console.log(res,'获取所有试题')
            this.choiceLists = res.data['多选'].reverse()
            this.choiceLists.forEach((item,index) => {
                let tempArr = []
                item.answer.forEach( answerItem => {
                    tempArr.push(item.options.indexOf(answerItem))
                })
                this.correctResultsArr[index] = tempArr
                this.errorResultsArr[index] = []
                this.formChosenResults[index] = {}
            })
            console.log(this.correctResultsArr,'单选题正确答案的集合')
            console.log(this.errorResultsArr,'单选题错误答案的集合')
            this.$toast.clear()
        }).catch( err => {
            this.$toast.clear()
            this.$toast( err.response.data.message)
        })
        // this.dialogImg = this.errorImg
        // this.confirmBtnText = '查看错题'
        // this.dialogMessage = '很抱歉，您没有通过单选环节考核'
    },

    methods: {
        //选中多选题
        chooseChoice(index,cindex) {
            if(!this.chosenResultsArr[index]) {
                this.chosenResultsArr[index] =[]
            }
            if(this.chosenResultsArr[index] && this.chosenResultsArr[index].includes(cindex)) {
                this.chosenResultsArr[index].splice(this.chosenResultsArr[index].indexOf(cindex),1)
            }else {
                this.chosenResultsArr[index].push(cindex)
            }
            if(this.chosenResultsArr[index]) {
                let tempArr = []
                this.chosenResultsArr[index].forEach( answerItem => {
                    tempArr.push(this.choiceLists[index].options[answerItem])
                })
                this.formChosenResults[index] = {
                    exam_id:this.choiceLists[index].id,
                    doctor_id:this.doctorInfo.id,
                    answer:tempArr
                }
            } else {
                this.formChosenResults[index] = {
                    exam_id:this.choiceLists[index].id,
                    doctor_id:this.doctorInfo.id,
                    answer:[]
                }
            }
            console.log(this.formChosenResults,'提交的表单答案');
            this.$forceUpdate()
            console.log(this.chosenResultsArr[index]);
            console.log(this.chosenResultsArr);
        },

        //返回上一页
        goBackStep() {
            this.$router.replace({
                name:'ExamVideo'
            })
        },

        //提交答案
        submit() {
            if(this.submitBtnText == '提交') {
                this.btnDisabled = true
                if(this.chosenResultsArr.length != this.choiceLists.length) {
                    this.btnDisabled = false
                    this.$toast('您有未做完的试题')
                    return
                }

                for(let i=0;i<this.chosenResultsArr.length;i++) {
                    if(!this.chosenResultsArr[i] || this.chosenResultsArr[i] && this.chosenResultsArr[i].length === 0) {
                        this.btnDisabled = false
                        this.$toast('您有未做完的试题')
                        return
                    }
                }
                this.$toast.loading({
                    message:'提交试题中',
                    duration:0,
                    forbidClick:true
                })
                console.log(this.errorResultsArr,'多选题错误答案的集合')
                SubmitDocExamRecord({
                    doctor_id:this.doctorInfo.id,
                    questions:this.formChosenResults
                }).then( res => {
                    console.log(res,'提交考题答案的返回结果')
                    if(res.data) {
                        this.dialogImg = this.correctImg
                        this.confirmBtnText = '继续申请'
                        this.dialogMessage = '恭喜您通过多选环节考试'
                    } else {
                        this.dialogImg = this.errorImg
                        this.confirmBtnText = '查看错题'
                        this.dialogMessage = '很抱歉，您没有通过多选环节考核'
                    }
                    this.$toast.clear()
                    this.showDialog = true
                }).catch( err => {
                    this.$toast.clear()
                    this.$toast(err.response.data.message) 
                    this.btnDisabled = false
                })

            } else {
                this.chosenResultsArr = []
                this.errorResultsArr = []
                this.showErrorChoices = false
                this.submitBtnText = '提交'
            }
        },

        //处理对话框确认点击事件
        handleDialogConfirm() {
            if(this.confirmBtnText == '查看错题') {
                this.submitBtnText = '重新答题'
                this.btnDisabled = false
                this.choiceLists.forEach( (item,index) => {
                    let tempArr = []
                    this.chosenResultsArr[index].forEach( chosenIndex => {
                        if(!item.answer.includes(item.options[chosenIndex])) {
                            tempArr.push(chosenIndex)
                            this.errorResultsArr[index] = tempArr
                        }
                    })

                    item.answer.forEach( (answerItem) => {
                        if(!this.chosenResultsArr[index].includes(item.options.indexOf(answerItem))) {
                            tempArr.push(item.options.indexOf(answerItem))
                            this.errorResultsArr[index] = tempArr
                        }
                    })
                })
                this.showErrorChoices = true
            } else {
                this.$router.replace({
                    name:'ExamIndex',
                    query:{
                        isRecord:true
                    }
                })
            }
        }
    }
}
</script>